// Angular
import { Injectable } from '@angular/core';

// Rxjs
import { Observable, combineLatest } from 'rxjs';

// Services
import { ApiService } from '../api/api.service';

// Helpers
import { Base64 } from '../../lib/helpers/utils';

// Models
import { Gift, GiftHelper } from '../../models/b2b/gift';
import { User, UserHelper } from '../../models/b2b/user';
import { AppState } from '../../../store';
import { Store } from '@ngrx/store';
import { Subscriber } from '../../lib/helpers/subscriber';
import { map } from 'rxjs/operators';
import { validateApiResponse } from 'app/shared/lib/custom-rxjs-operators/api-response.operator';

@Injectable()
export class SoledadGiftsService extends Subscriber {
    private addressCode: number = null;

    constructor(
        private api: ApiService,
        private store: Store<AppState>
    ) {
        super();
        this.addSubscription(
            combineLatest([this.store.select((state) => state.user?.data.selectedAddressCode)]).subscribe(
                ([selectedAddressCode]) => {
                    this.addressCode = selectedAddressCode;
                }
            )
        );
    }

    getGifts(selectedAddress: number = null): Observable<Gift[]> {
        const params = [];
        // params['CLIENTE'] = user.clienteCodigo;
        // params['FECHADESDE'] = '';
        // params['FECHAHASTA'] = '';
        // params['BUSQUEDA'] = '';
        return this.getGiftsByParams(params, selectedAddress);
    }
    getGiftsByParams(params: any[], selectedAddress: number = null): Observable<Gift[]> {
        params['AGRUPADAS'] = true;
        if (selectedAddress || typeof selectedAddress === 'number') {
            params['DIRECCION'] = selectedAddress;
        } else if (typeof this.addressCode === 'number') {
            params['DIRECCION'] = this.addressCode;
        }
        return this.api.callSoledad('b2bnew.dbo.HTML_PromosPedidoYAcumulativas_REGALO', params).pipe(
            validateApiResponse('Error obteniendo regalos' + '. Params: ' + JSON.stringify(params)),
            map((data: any[]) => {
                return data.map((gift: any) => GiftHelper.transformFromApi(gift));
            })
        );
    }
    getGiftsByIdPromo(idpromo: string) {
        const params = [];
        params['IDPROMO'] = idpromo;

        return this.getGiftsByParams(params);
    }

    getGiftsByDate(fechaDesde: string, fechaHasta: string, giftAddress: number = null): Observable<Gift[]> {
        const params = [];
        params['FECHADESDE'] = fechaDesde;
        params['FECHAHASTA'] = fechaHasta;

        return this.getGiftsByParams(params, giftAddress);
    }

    getGiftsByDateAndQuery(fechaDesde: string, fechaHasta: string, query: string): Observable<Gift[]> {
        const params = [];
        params['FECHADESDE'] = fechaDesde;
        params['FECHAHASTA'] = fechaHasta;
        params['BUSQUEDA'] = query;

        return this.getGiftsByParams(params);
    }

    canjearRegalos(regalos: Array<any>, user: User): Observable<any> {
        let params = [];
        let rows = [];
        let count = 1;
        const address = UserHelper.getSelectedAddress(user);

        regalos.map((it) => {
            const row = [];
            const name = it.type == 'OPCIONES' ? it.nameGift + ' (' + it.name + ')' : it.name;
            const options = it.type == 'OPCIONES' ? it.name : '';

            row.push('LINEA=>' + count);
            row.push('IDPROMOREGALO=>' + it.regalo.idOrig);
            row.push('NOMBRE=>' + name);
            row.push('OPCION=>' + options);
            row.push('CANTIDAD=>' + it.cantidad);
            row.push('PRECIO=>' + it.regalo.precio);

            rows.push(row.join('&&'));
            count++;
        });

        params['ROWS'] = Base64.encode(rows.join('##') + '##');
        params['CLIENTE'] = user.clienteCodigo;
        params['DIRECCION'] = address.codigo;

        return this.api.callSoledad('b2bnew.dbo.HTML_PromosGrabarPedido', params).pipe(
            map((data) => {
                return data;
            })
        );
    }

    downloadGift(ids: string): Observable<any> {
        const params = [];
        params['IDS'] = ids;
        return this.api.callSoledad('b2bnew.dbo.HTML_PromosGrabarDescarga', params).pipe(
            map((data) => {
                return data;
                // return { result: 0, value: 'OK'};
            })
        );
    }
}
